import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kp2u3q5vh: FaireProductEntity = {
  token: "p_8kp2u3q5vh",
  type: "product",
  name: "Soft Baby Shoes - Handmade Cotton Booties",
  brandToken: "b_64bone32",
  brandName: "Tiny Treasures Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/bf29028bd5fd774e2973bbfc7a64a3b11e154812861a4a8d0bbc8f38256d2015.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da32fa350e256d929fc6527277d720ca45509b0e7581d5eafc749ccc7f1540f7.png",
    "https://cdn.faire.com/fastly/1dceb0b7c53fdf9bdd75f669b71194037eb2715f379bec094485f3a458bad485.png",
    "https://cdn.faire.com/fastly/53be46ec7ad2a7f767ebae2d1d002dc7baca0fab8fc32718c53a2d61757d6cc2.png",
    "https://cdn.faire.com/fastly/f61cadb12e53449426ffefa2cfbe1729e7da119acfc8a9accab9b0e2c15dbe9a.png",
    "https://cdn.faire.com/fastly/14a3a46381c4c3f1d86f3ea02467fe9d82f36ce155484a6058b68bcf034ef848.png",
    "https://cdn.faire.com/fastly/29f6ef46f9fb7541b807b77b469a3f49ba51dd27a619e97874fd8ca49668427d.png",
    "https://cdn.faire.com/fastly/975b3886a6e4c29765398f0819692a5a2c5e6069b87e63c19a307900563d9c80.png",
    "https://cdn.faire.com/fastly/620ac4651e159e8392b422a466adfe2f17f9d36535e34a988e5e97b04f10753d.png",
    "https://cdn.faire.com/fastly/9311a42c79e2fbd04f4c56502f0a9aa8c69aea45214f1bcb66dcdd41ade076bc.png",
    "https://cdn.faire.com/fastly/c5d8347c9a792017743693f98a394ab9e8bc0cbd6686b434d6e94b477b75544a.png",
    "https://cdn.faire.com/fastly/f9cdb10ffbc81525f3d30e274868d89ba1fa2bbf36af694d5a6b01518ecb5da3.png",
    "https://cdn.faire.com/fastly/7837f1012459d3fa2e294ad8dd805b2c6e29d8998a5429a15ded5a7abe928199.png",
    "https://cdn.faire.com/fastly/6d7a7be812ad5473072d36526a601da0ce05ff008b3c592a328615599ded6bc6.png",
    "https://cdn.faire.com/fastly/04c73b59e6de6c87f391b523d45fd88cb494707ff5fa83e804387482825fd278.png",
    "https://cdn.faire.com/fastly/a3afd0cb99e37eaf2e5a990ad10bd19d19932c14b5f4a12fac168c6f0730f08a.png",
    "https://cdn.faire.com/fastly/9391258c6127578ec12db26a1c5b6f7079e5d204c7029075997d0cc849334d5b.png",
    "https://cdn.faire.com/fastly/2bc4b9a27cd0c293a842b0a83fd739cae6e4e8ac72ab2696cb45e0624d09eaf1.png",
    "https://cdn.faire.com/fastly/d9e6a36d61c8bb1fdd9a6c610de59d33e64e1b174a82f0d42e082457d1b705cb.png",
    "https://cdn.faire.com/fastly/64dc74535b904229dd6e1ed880eef599a75063671aa811a011c06d22ec13236a.png",
    "https://cdn.faire.com/fastly/f5dfedf4c7d6c1db92b53c51fd7cda7231ac142952d794c44933007ca26a075c.png",
    "https://cdn.faire.com/fastly/4d52b9820af210b4ce0d09ffdf4784b6c3dd375d03e801c7efd9cadc88af0f7b.png",
    "https://cdn.faire.com/fastly/87d1f69095b913709804311d0fbf5dd6a9b8079afb183063dec0f122155acbbf.png",
    "https://cdn.faire.com/fastly/e27add10ad50488f455b0b36dc310551dad538e6f3ea0b08ce43f6e7bdf89b79.png",
    "https://cdn.faire.com/fastly/b2dbb4e7f0226f96ff1ec3637e80e24bbb4ad66f5d5f41b32f1498b879bcf495.png",
    "https://cdn.faire.com/fastly/3864263352c6a5ba702a260c783894ce3a2c63b397ddfe10dee4eb084cef13d1.png",
    "https://cdn.faire.com/fastly/eb8853cbc487e2c6f5c8d6fc8a7010f5e295b98c5eb8f5b9982a1e4913002d8a.png",
  ],
  priceDollars: 9,
  description:
    "Handmade Baby Shoes – A Perfect Gift to Give or Keep\nThoughtfully crafted for comfort and cuteness, our handmade baby shoes are a beautiful blend of style and practicality. Whether you're shopping for your own baby or gifting to a new parent, these soft shoes are designed to grow with little feet—making them a keepsake they'll actually use.\n\nFeatures:\n👶 Baby-Friendly Sizing – Available in sizes from 0–18 months to grow with baby\n🎨 Designer Cotton Uppers – Premium, breathable fabric in a range of charming prints\n☁️ Cotton Fleece Lining – Gentle and cozy against sensitive baby skin\n🦶 Grippy Soles – Non-slip bottoms for early crawlers and first steps\n🎁 Gift-Ready – Makes a thoughtful gift for baby showers, birthdays, or “just because”",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:46.674Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
